import React from "react";
import Experience from '../components/sections/Experience/Experience';
import About from './../components/sections/About/About';
import Blogs from './../components/sections/Blogs/Blogs';
import Contacts from './../components/sections/Contacts/Contacts';
import { ExperienceItem } from './../components/sections/Experience/Experience';
import PageSection from './../components/sections/PageSection';
import Auxilary from './../Layout/Auxilary';
import Resume from './../components/sections/Resume/Resume';
import { portfolioData } from '../data/portfolio';

const HomePage = () => {
    return (
        <Auxilary>
            <div className="min-h-screen bg-gray-50">
                <div className="container mx-auto px-4 py-8">
                    <PageSection id="about">
                        <div className="animate-fade-in">
                            <About />
                        </div>
                    </PageSection>

                    <PageSection id="experience">
                        <div className="space-y-8 animate-slide-up">
                            <Experience>
                                {portfolioData.experience.map((job, index) => (
                                    <ExperienceItem
                                        key={index}
                                        title={job.title}
                                        timeline={job.timeline}
                                        logo={job.logo}
                                        techstack={job.techstack}
                                        designation={(<strong className="text-primary-600 font-semibold">{job.designation}</strong>)}
                                        projectImage={job.projectImage}
                                    >
                                        <div className="project-responsibility">
                                            {job.projects ? (
                                                // If there are projects (e.g. Adobe, Wipro)
                                                <ul>
                                                    {job.projects.map((project, pIndex) => (
                                                        <React.Fragment key={pIndex}>
                                                            <span className="project-sub-title black">{project.title}</span>
                                                            {project.description.map((desc, dIndex) => (
                                                                <li key={dIndex}>{desc}</li>
                                                            ))}
                                                        </React.Fragment>
                                                    ))}
                                                </ul>
                                            ) : (
                                                // If it's a direct description list (e.g. Fidelity)
                                                <ul>
                                                    {job.description.map((desc, dIndex) => (
                                                        <li key={dIndex}>{desc}</li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </ExperienceItem>
                                ))}
                            </Experience>
                        </div>
                    </PageSection>

                    <PageSection id="blogs">
                        <div className="animate-fade-in">
                            <Blogs />
                        </div>
                    </PageSection>

                    <PageSection id="resume">
                        <div className="animate-fade-in">
                            <Resume />
                        </div>
                    </PageSection>

                    <PageSection title="" id="contact">
                        <div className="animate-fade-in">
                            <Contacts />
                        </div>
                    </PageSection>
                </div>
            </div>
        </Auxilary>
    );
}

export default HomePage;